module.exports = __webpack_public_path__ + "img/icon-png.0168c0d4.svg";